/**
 * 注册信息
 */
export type RegisterUser = {
  mobile: string;
  signature: string;
  verificationCode:string;
};
const state: RegisterUser = {
  mobile: "",
  signature: "",
  verificationCode:""
};

const mutations = {
  setMobile(state: RegisterUser, mobile) {
    state.mobile = mobile;
  },
  setVerificationCode(state: RegisterUser, verificationCode) {
    state.verificationCode = verificationCode;
  },
  setSignature(state: RegisterUser, signature) {
    state.signature = signature;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
